import React from 'react';

const StatsTable = ({ stats }) => (
  <table className="table table-striped table-hover table-bordered">
  <thead className="thead-inverse">
    <tr>
      <th></th>
      <th>My Website</th>
      <th>The Average Website</th>
    </tr>
  </thead>
  <tbody>
    {stats.map(stat => (
      <tr key={stat.label}>
        <th width="40%" scope="row">{stat.label}</th>
        <td width="22%" className="text-success">{stat.mine}</td>
        <td width="38%" className="text-danger">{stat.theirs}</td>
      </tr>
    ))}
  </tbody>
</table>
);

export default StatsTable;


// WEBPACK FOOTER //
// ./src/components/StatsTable.js